import React, {createContext, useEffect, useState} from "react";


export const ShopContext = createContext({});

// ─── Line key helper ────────────────────────────────────────────────────────
// Must match the backend's makeLineKey: "productId_colorHex_size"
export const makeLineKey = (productId, colorHex = "", size = "") =>
    `${productId}_${colorHex}_${size}`;


const ShopContextProvider = (props) => {

    const [all_products, setAll_products] = useState([]);

    // cartItems shape: { [lineKey]: { productId, quantity, size, color: {name,hex}|null } }
    const[cartItems, setCartItems] = useState({});

    const products = all_products;

    useEffect(()=>{
        // fetch all products
        fetch(`${process.env.REACT_APP_API_URL}/all-products`)
        .then((response)=>response.json())
        .then((data)=>setAll_products(data));

        // restore cart from backend if logged in
        if(localStorage.getItem('auth-token')){
            fetch(`${process.env.REACT_APP_API_URL}/get-cart-data`, {
                method: 'POST',
                headers: {
                    Accept: 'application/form-data',
                    'auth-token':`${localStorage.getItem("auth-token")}`,
                    'Content-Type':'application/json'
                },
                body:""
            }).then((response)=>response.json())
            .then((data)=>setCartItems(data || {} ));
        }
    },[])

    const addToCart = (productId, size = "", color = null) => {
        const lineKey = makeLineKey(productId, color?.hex || "", size);

        setCartItems(prev => {
            const existing = prev[lineKey];
            return {
                ...prev,
                [lineKey]: existing
                    ? { ...existing, quantity: existing.quantity + 1 }
                    : { productId, quantity: 1, size: size || "", color: color || null }
            };
        });

        if(localStorage.getItem('auth-token')){
            fetch( `${process.env.REACT_APP_API_URL}/add-to-cart`, {
                method: 'POST',
                headers: {
                    Accept: 'application/form-data',
                    'auth-token': `${localStorage.getItem("auth-token")}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({productId, size, color})
            })
            .then((response) => response.json())
            .then((data) => console.log("add-to-cart: ", data));
        }
        //add else to handle case when user is not logged in and tries to add item to cart (optional) and it needs to be a alert
    };

    // completely removes an item from the cart by resetting its quantity to zero
    const removeFromCart = (lineKey) => {
        setCartItems(prev => {
            const next = { ...prev };
            delete next[lineKey];
            return next;
        });

        if(localStorage.getItem('auth-token')){
            fetch(`${process.env.REACT_APP_API_URL}/remove-from-cart`, {
                method: 'POST',
                headers: {
                    Accept: 'application/form-data',
                    'auth-token': `${localStorage.getItem("auth-token")}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ lineKey })
            })
            .then((response) => response.json())
            .then((data) => console.log("removed-from-cart: ", data));
        }
    };

    // decrement the quantity of an item by one (but not below zero)
    const decrementQuantity = (lineKey) => {
        setCartItems(prev => {
            const existing = prev[lineKey];
            if (!existing) return prev;
            if (existing.quantity <= 1) {
                const next = { ...prev };
                delete next[lineKey];
                return next;
            }
            return { ...prev, [lineKey]: { ...existing, quantity: existing.quantity - 1 } };
        });

        if(localStorage.getItem('auth-token')){
            fetch(`${process.env.REACT_APP_API_URL}/decrement-cart`, {
                method: 'POST',
                headers: {
                    Accept: 'application/form-data',
                    'auth-token': `${localStorage.getItem("auth-token")}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ lineKey })
            })
            .then((response) => response.json())
            .then((data) => console.log("decrement-cart: ", data));
        }
    };

    // ── clearCart — wipes all cart state after a successful order ─────────────
    const clearCart = () => {
        setCartItems({});
    };

    // calculates the total price of all items in the cart
    const getTotalCartPrice = () => {
        let totalPrice = 0;
        for(const lineKey in cartItems) {
            const line = cartItems[lineKey];
            if (!line || typeof line.quantity !== 'number') continue;
            let product = products.find((product) => product.id === Number(line.productId));
            if(product) {
                totalPrice += line.quantity * product.price;
            }
        }
        return totalPrice;
    };

    //navbar cart count
    const getTotalCartCount = () => {
        let totalCount = 0;
        for(const lineKey in cartItems) {
            const line = cartItems[lineKey];
            if (!line || typeof line.quantity !== 'number') continue;
            totalCount += line.quantity;
        }
        return totalCount;
    };

    return (
        <ShopContext.Provider value={{
            products,
            all_products: products,
            cartItems,
            addToCart,
            removeFromCart,
            decrementQuantity,
            getTotalCartPrice,
            getTotalCartCount,
            clearCart
        }}>
            {props.children}
        </ShopContext.Provider>
    )
}

export default ShopContextProvider;